const translations = {
  'privacy.seo.title': 'Our Privacy Policy',
  'privacy.seo.description': "Find out more about TEFL Iberia's privacy policy.",
};

export default translations;
